namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	import ISoundManager = Roodik.Core.ISoundManager;
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	import LocalizationManager = Roodik.Core.LocalizationManager;
	import IAnalytics = Roodik.Core.IAnalytics;

	export class SponsorPanelView extends ViewBase
	{
		private _noBtn:SimpleButton;
		private _yesBtn:SimpleButton;
		private _message : PIXI.Text;
		private _rewardText : PIXI.Text;

		constructor(private _localizationManager:LocalizationManager,
		            private _soundManager:ISoundManager,
		            private _analytics:IAnalytics,
		            private _clickYes:()=>void,
		            private _clickNo:()=>void)
		{
			super("SponsorHelpPanelView");

			this._analytics.sendEvent("Reward","Proposed","");

			this.createCloseButton();
			this.createMessage();
			this.createRewardInfo();
			this.show();
		}

		private createRewardInfo()
		{
			this._rewardText = new PIXI.Text("+1 "+this._localizationManager.getString(LocalizationKey.RESHUFFLE),
			{
				fontFamily: 'WellWait',
				fontSize: 50,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: ['#FFA500', '#FFD700'],//'#FFD700',//['#FFD700', '#4a1850'], // gradient
				stroke: '#ffffff',//'#338d13',
				strokeThickness: 5,
				wordWrap: true,
				wordWrapWidth:600,
				dropShadow: true,
				dropShadowColor: '#ffffff',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,
				padding:20
			});
			this._rewardText.x = -this._rewardText.width*0.5-10;
			this._rewardText.y = -160;
			this.addChild(this._rewardText);
		}

		private createMessage()
		{
			this._message = new PIXI.Text(this._localizationManager.getString(LocalizationKey.REWARDED_VIDEO_DESCRIPTION),
			this.titleStyle(40, ['#ffffff', ], '#000000', "center",1));
			this._message.x = -this._message.width*0.5 - 10;
			this._message.y = -25;
			this.addChild(this._message);

		}

		private titleStyle(fontSize:number, fillColor:any, strokeColor:string, align:string = "center", strokeThickness:number = 5)
		{
			return {
				fontFamily: 'WellWait',
				fontSize: fontSize,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: fillColor,//'#FFD700',//['#FFD700', '#4a1850'], // gradient
				stroke: strokeColor,//'#ffffff',//'#338d13',
				strokeThickness: 5,
				align:align,
				dropShadow: true,
				dropShadowColor: strokeColor,//'#ffffff',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			}
		}

		private createCloseButton()
		{
			this._noBtn = new SimpleButton(this.childByName("No").display,
			this._localizationManager.getString(LocalizationKey.BUTTON_CANCEL), this.getButtonTextStyle());
			this._noBtn.events.on(SimpleButton.CLICKED, this.clickNo.bind(this));

			this._yesBtn = new SimpleButton(this.childByName("Yes").display,
			this._localizationManager.getString(LocalizationKey.BUTTON_AGREE), this.getButtonTextStyle());
			this._yesBtn.events.on(SimpleButton.CLICKED, this.clickYes.bind(this));
		}

		private clickYes()
		{
			this._analytics.sendEvent("Reward","Accepted","");
			this.hide(true);
		}

		private clickNo()
		{
			this._analytics.sendEvent("Reward","Rejected","");
			this.hide(false);
		}

		private show()
		{
			this.alpha = 0;
			this.y = 300;
			let properties = {alpha:this.alpha, y:this.y};
			new Tween(properties)
			.to({alpha: 1, y: 0}, 150)
			.easing(Easing.Quadratic.In)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.start();
		}

		private hide(yes:boolean)
		{
			this._soundManager.playSound("click.mp3", 1);

			let properties = {alpha:this.alpha,y:this.y};
			new Tween(properties)
			.to({alpha: 0, y: -300}, 150)
			.easing(Easing.Quadratic.Out)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(function ()
			{
				if (yes)
				{
					this._clickYes();
				}
				else
				{
					this._clickNo();
				}
			}.bind(this))
			.start();
		}

		private getButtonTextStyle()
		{
			return {
				fontFamily: 'WellWait',
				fontSize: 35,
				fill: '#FFDEAD',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				align:"center",
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			}
		}

		public destroy()
		{
			this.removeChild(this._message);
			this.removeChild(this._rewardText);
			this._message.destroy();
			this._rewardText.destroy();

			this._noBtn.events.off(SimpleButton.CLICKED, this.clickNo.bind(this));
			this._yesBtn.events.off(SimpleButton.CLICKED, this.clickYes.bind(this));

			this._noBtn.destroy();
			this._yesBtn.destroy();

			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/SponsorPanelView.ts